import { render, staticRenderFns } from "./GitHubButton.vue?vue&type=template&id=9d058126&scoped=true&"
import script from "./GitHubButton.vue?vue&type=script&lang=js&"
export * from "./GitHubButton.vue?vue&type=script&lang=js&"
import style0 from "./GitHubButton.vue?vue&type=style&index=0&id=9d058126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d058126",
  null
  
)

export default component.exports